import Socket from '@/utils/socket'
import formatReceiveMessageName from '@/utils/message_receive'
import timer from '@/utils/timer'
import { nowTimestamp, isObject } from '@/utils'
import { getSocketConfig } from '@/api/chat'
import {
    STATUS,
    HOST,
    MESSAGE_NAME,
    NO_IN_LIST_MESSAGE,
    CHAT_NOTICE,
    EVALUATION_VALUE
} from '@/constants/message'
import {
    SHOW_EVALUATION_DIALOG,
    SHOW_LEAVE_MESSAGE_DIALOG,
    TIME_TO_INSERT_WELCOME
} from '@/constants/pub_sub'

const DELAY_REMOVE_SOCKET_SUCCESS = 2000 // 多少时间后删除“连接成功”消息
const SOCKET_CONNECT_OVERTIME = 10 * 1000 // socket 多少时间内未连接成功则认为超时（连接失败）
const TEN_MINUTES = 10 * 60 * 1000
let IS_FIRSTTIMES = true //第一次进入会话

/**
 * socket 推过来的消息(子项)处理（若是嵌套消息，则遍历嵌套的消息）
 */
function handleItem (message, messageData) {
    if(IS_FIRSTTIMES) {
        window.parent.postMessage(false, '*')
        IS_FIRSTTIMES = false
    }
    if (message.from == 'robot' || message.from == 'system') {
        this.$eventBus.$emit('showinputstatus', {is_input:false})
    }
    const name = formatReceiveMessageName(
        messageData.detail_type,
        messageData.data
    )
    if (!name) {
        // eslint-disable-next-line
        console.error('未知消息类型', message)
        return
    }
    if (CHAT_NOTICE.includes(name)) {
        this.$eventBus.getCurrentHumanUser()
    }
    if (NO_IN_LIST_MESSAGE.includes(name)) {
        this.noRender(name, messageData)
        return
    }

    const robot = {}

    const evaluationValue = getEvaluationValue(message, messageData)

    if (typeof evaluationValue !== 'undefined') {
        robot.evaluationValue = evaluationValue
    }

    this.appendMessage(Object.assign({
        name,
        host: HOST.SERVICE,
        content: messageData.show_data || messageData.data,
        server: {
            id: message.id,
            timestamp: message.timestamp,
            fromId: message.from_id,
            from: message.from
        },
        isUnread: false
    }, Object.keys(robot).length > 0 ? { robot } : {}))
}

/**
 * 获取机器人消息的评价值
 * @returns {undefined | Number} undefined 表示该消息无需评价、
 * Number 是 EVALUATION_VALUE 对应的值
 */
function getEvaluationValue (message, messageData) {

    let result

    if (!isObject(message.ext) || messageData.detail_type !== 'text') {
        return result
    }

    const {
        is_solved: isSolved
    } = message.ext

    if (typeof isSolved !== 'undefined') {
        result = getValue(isSolved)
    }

    function getValue (isSolved) {
        if (isSolved === null) {
            return EVALUATION_VALUE.NONE
        } else {
            return EVALUATION_VALUE[isSolved ? 'UP' : 'DOWN']
        }
    }

    return result
}

export default {
    data () {
        return {
            socketOverTimeTimerId: -1,
            socketConnectSuccessTimerId: -1,
            socket: null,
            socketListeners: {
                publish: this.socketPublish,
                subscribe: this.socketSubscribe,
                unsubscribe: this.socketUnsubscribe,
                error: this.socketError,
                join: this.socketJoin,
                leave: this.socketLeave
            },
            socketEventMessageId: ''
        }
    },
    methods: {
        // S socket 事件订阅
        async initSocket () {
            const socketConfig = await getSocketConfig(this.entryKey, this.uid)
            const socket = Socket.getInstance({
                uid: this.uid,
                entryKey: this.entryKey,
                url: socketConfig.url,
                channel: socketConfig.channels.chat_user,
                token: socketConfig.token,
                listeners: this.socketListeners,
                connectListener: this.socketConnect,
                disconnectListener: this.socketDisconnect
            })
            socket.init()
            this.appendMessageSocketConnecting()
            this.$eventBus.$emit(TIME_TO_INSERT_WELCOME)
            this.socket = socket

            this.socketOverTimeTimerId = socketConnectOverTime.call(this)

            /**
             * Error in connection establishment: net::ERR_CONNECTION_REFUSED
             * 以上事件不会触发 error 监听事件，故通过定时器判断
             */
            function socketConnectOverTime () {
                return timer.add(SOCKET_CONNECT_OVERTIME, () => {
                    if (!this.$eventBus.isSocketConnected) {
                        this.socket.disconnect()
                        this.socketConnectFail()
                    }
                })
            }
        },
        socketConnect ({ client, transport, latency }) {
            // eslint-disable-next-line
            console.log('connect', client, transport, latency)
        },
        socketDisconnect ({ reason, reconnect }) {
            // eslint-disable-next-line
            console.log('disconnect', reason, reconnect)
            this.disconnectTimestamp = nowTimestamp()
        },
        /**
         * 服务器推消息过来
         * @param { Object } data
         * @param { Number } data.seq
         * @param { Object } data.data
         * @param { Number } data.data.timestamp
         * @param { String } data.data.from - robot、kf、kh、system
         * @param { String } data.data.from_id - 发送者 id
         * @param { String } data.data.to - robot、kf、kh、system
         * @param { String } data.data.to_id - 接收者 id
         * @param { String } data.data.source - 来源：h5、wechat
         * @param { String } data.data.ext - 扩展字段，用于存储多平台接入时必要的平台信息
         * ，如微信：open_id、appid
         * @param { Object | Object[] } data.data.data - 消息体，嵌套类型时，为对象数组
         * @param { String } data.data.data.type - event | base | ext
         * @param { String } data.data.data.detail_type - text | image | ...
         * @param { String | Object } data.data.data.data
         * @returns { Void }
         */
        socketPublish (data) {
            // eslint-disable-next-line
            const message = data.data
            const messageData = message.data
            if (messageData.detail_type === 'nested') {
                for (let i = 0; i < messageData.data.length; i++) {
                    handleItem.call(this, message, messageData.data[i])
                }
            } else {
                handleItem.call(this, message, messageData)
            }
        },
        // eslint-disable-next-line
        socketSubscribe ({ channel, isResubscribe }) {
            this.$eventBus.setGlobalSocketConnected(true)
            this.setMessageValueById(this.socketEventMessageId, 'content', {
                text: '连接成功',
                status: STATUS.SUCCESS
            })
            this.socketConnectSuccessTimerId = this.delayRemoveMessage(
                this.socketEventMessageId,
                DELAY_REMOVE_SOCKET_SUCCESS
            )
            this.$toast.clear()

            if (isResubscribe) {
                if (nowTimestamp() - this.disconnectTimestamp > TEN_MINUTES) {
                    this.reset()
                    return
                }
                this.getBeforeReconnectMessageList()
            }
        },
        socketUnsubscribe (context) {
            // eslint-disable-next-line
            console.log('unsubscribe', context)
            this.$eventBus.setGlobalSocketConnected(false)
            this.socketConnectFail()
        },
        socketError (error) {
            // eslint-disable-next-line
            console.log('error', error)
        },
        socketJoin (message) {
            // eslint-disable-next-line
            console.log('join', message)
        },
        socketLeave (message) {
            // eslint-disable-next-line
            console.log('leave', message)
        },
        // E socket 事件订阅

        // S socket 业务方法
        socketConnectFail () {
            timer.remove(this.socketConnectSuccessTimerId)
            timer.remove(this.socketOverTimeTimerId)
            this.setMessageValueById(this.socketEventMessageId, 'content', {
                text: '连接失败',
                status: STATUS.FAIL
            })
            this.$toast.clear()
        },
        noRender (name, { data }) {
            const strategies = {
                [MESSAGE_NAME.EVENT_CHAT_STATUS]: () => {
                    this.setChatHost(data)
                },
                [MESSAGE_NAME.EVENT_EVALUATION]: () => {
                    this.$eventBus.$emit(SHOW_EVALUATION_DIALOG, data)
                },
                [MESSAGE_NAME.EVENT_LEAVE_MESSAGE]: () => {
                    this.$eventBus.$emit(SHOW_LEAVE_MESSAGE_DIALOG)
                },
                [MESSAGE_NAME.EVENT_WITHDRAW]: () => {
                    this.withdrawMessage(name, data)
                },
                [MESSAGE_NAME.EVENT_SESSION_MONITOR]: () => {
                    /**
                     * 发消息或重发消息（可能）的 POST 请求的返回（需要拿到 idFromServer 字段）
                     * 和 scoket 推送的 EVENT_SESSION_MONITOR 消息，两者顺序不确定
                     */
                    this.updateSensitiveMessageContent(name, data)
                },
                [MESSAGE_NAME.INPUT_STATUS]: () => {
                    this.$eventBus.$emit('showinputstatus', data)
                },
                [MESSAGE_NAME.READED]: () => {
                    this.unReadHandler(data)
                },
                [MESSAGE_NAME.INVITE]: () => {
                    let isopen = 'opensuccess'
                    window.parent.postMessage(isopen, '*')
                },
                [MESSAGE_NAME.SHOWBTN]: () => {
                    this.$eventBus.robot.hide_human_button = false
                }
            }
            strategies[name](data)
        },
        // E socket 业务方法
    },
    beforeDestroy () {
        this.socket.disconnect()
        this.socket = null
    }
}
